// Google OAuth client id helper for supplier GSI redirect (AuthContext).
// Credential JWT decode / One-Tap demo paths removed (TA-031 / TA-085).
import { googleConfig } from '@/config'

const googleAuthService = {
  get clientId() {
    return googleConfig.clientId
  },
}

export default googleAuthService
